import { useState, useEffect, useRef } from "react";
import Logo from "./common/Logo";
import MobileMenuButton from "./common/MobileMenuButton";
import NavigationLinks from "./common/NavigationLinks";
import AuthButtons from "./common/AuthButtons";
import LanguageButtons from "./common/LanguageButtons";

const MobileHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <div ref={menuRef} className="relative w-full flex items-center justify-between">
      <Logo />
      <MobileMenuButton isOpen={isMenuOpen} onClick={() => setIsMenuOpen(!isMenuOpen)} />

      {isMenuOpen && (
        <div className="absolute top-full left-0 right-0 lg:hidden z-40">
          <div 
            className={`overflow-hidden transition-all duration-300 ease-in-out ${
              isMenuOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
            }`}
          >
            <div className="bg-gray-900/95 backdrop-blur-lg border-t border-gray-700 py-6 px-4 max-h-[calc(100vh-80px)] overflow-y-auto">
              <div className="space-y-6">
                <NavigationLinks variant="mobile" onLinkClick={() => setIsMenuOpen(false)} />
                <AuthButtons variant="mobile" />
                <LanguageButtons />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileHeader;
